export default function emptyToUndefined<T = unknown[]>(o: T) {
  return o && Object.keys(o).length ? o : undefined
}
